export default "__VITE_ASSET__Ci$r51K4__"